import ApiClient from './ApiClient';

const EmailDraftService = {
    getEmails: (token) => {
        return ApiClient.get('/api/azure/emails', {
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            }
        });
    },
    createDraft: (data, token) => {
        return ApiClient.post('/api/azure/create_draft', data, {
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            }
        });
    }
};

export default EmailDraftService;